import React, { useState, useEffect, useRef } from 'react';

const API_URL = 'https://skortes.com';

export default function ProfilShortcut({ onLihatProfilLengkap }) {
  const [buka, setBuka] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const ref = useRef(null);

  const userData = (() => { try { return JSON.parse(localStorage.getItem('user')); } catch { return null; } })();
  const namaUser = userData?.nama || 'Peserta';
  const inisial = namaUser.charAt(0).toUpperCase();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) { setLoading(false); return; }
    fetch(`${API_URL}/api/gamifikasi/ringkasan`, { headers: { Authorization: `Bearer ${token}` } })
      .then(r => r.json())
      .then(d => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  // Tutup dropdown kalau klik di luar area
  useEffect(() => {
    const handleKlikLuar = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setBuka(false);
    };
    document.addEventListener('mousedown', handleKlikLuar);
    document.addEventListener('touchstart', handleKlikLuar);
    return () => {
      document.removeEventListener('mousedown', handleKlikLuar);
      document.removeEventListener('touchstart', handleKlikLuar);
    };
  }, []);

  const persenLevel = data ? Math.min(100, Math.round((data.progresLevel / data.xpPerLevel) * 100)) : 0;
  const badgeTercapai = data ? data.badges.filter(b => b.tercapai) : [];

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setBuka(b => !b)}
        className="w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm flex-shrink-0"
        style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--accent)', border: '2px solid var(--accent)' }}>
        {inisial}
      </button>

      {buka && (
        <div className="absolute right-0 top-12 z-50 rounded-xl overflow-hidden shadow-lg"
             style={{ width: 260, backgroundColor: 'var(--bg-card)', border: '1px solid var(--border)' }}>
          {/* Identitas */}
          <div className="px-4 py-3 flex items-center gap-3" style={{ backgroundColor: 'var(--bg-card2)', borderBottom: '1px solid var(--border)' }}>
            <div className="w-11 h-11 rounded-full flex items-center justify-center font-bold text-base flex-shrink-0"
                 style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--accent)', border: '2px solid var(--accent)' }}>
              {inisial}
            </div>
            <div className="min-w-0">
              <p className="text-sm font-bold truncate" style={{ color: 'var(--text-primary)' }}>{namaUser}</p>
              <p className="text-[11px]" style={{ color: 'var(--text-muted)' }}>{userData?.jalur || 'belum pilih jalur'}</p>
            </div>
          </div>

          {loading ? (
            <p className="text-center text-xs py-6" style={{ color: 'var(--text-muted)' }}>Memuat...</p>
          ) : !data ? (
            <p className="text-center text-xs py-6" style={{ color: 'var(--text-muted)' }}>Gagal memuat data.</p>
          ) : (
            <div className="px-4 py-3 space-y-3">
              {/* Level & XP */}
              <div>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-xs font-semibold" style={{ color: 'var(--text-primary)' }}>⭐ Level {data.level}</span>
                  <span className="text-[10px] font-mono" style={{ color: 'var(--accent)' }}>{data.progresLevel}/{data.xpPerLevel} XP</span>
                </div>
                <div className="h-1.5 rounded-full overflow-hidden" style={{ backgroundColor: 'var(--bg-card3)' }}>
                  <div className="h-full rounded-full" style={{ width: `${persenLevel}%`, backgroundColor: 'var(--accent)' }} />
                </div>
              </div>

              {/* Streak & lencana */}
              <div className="grid grid-cols-2 gap-2">
                <div className="rounded-lg p-2 text-center" style={{ backgroundColor: 'var(--bg-card2)' }}>
                  <p className="text-base font-bold font-mono" style={{ color: data.streak > 0 ? '#FBBF24' : 'var(--text-muted)' }}>
                    {data.streak > 0 ? `${data.streak}🔥` : '—'}
                  </p>
                  <p className="text-[9px] uppercase" style={{ color: 'var(--text-muted)' }}>Streak</p>
                </div>
                <div className="rounded-lg p-2 text-center" style={{ backgroundColor: 'var(--bg-card2)' }}>
                  <p className="text-base font-bold font-mono" style={{ color: 'var(--text-primary)' }}>{badgeTercapai.length}/{data.badges.length}</p>
                  <p className="text-[9px] uppercase" style={{ color: 'var(--text-muted)' }}>Lencana</p>
                </div>
              </div>

              {/* Daily challenge */}
              {data.dailyChallenge && (
                <div className="rounded-lg px-3 py-2 text-[11px]" style={{ backgroundColor: data.dailyChallenge.selesai ? 'rgba(74,222,128,0.1)' : 'var(--bg-card2)', color: data.dailyChallenge.selesai ? 'var(--success)' : 'var(--text-muted)' }}>
                  {data.dailyChallenge.selesai ? '✅ Daily Challenge hari ini selesai' : '🎯 Selesaikan 1 sesi hari ini untuk bonus XP'}
                </div>
              )}
            </div>
          )}

          <button
            onClick={() => { setBuka(false); onLihatProfilLengkap && onLihatProfilLengkap(); }}
            className="w-full py-2.5 text-xs font-semibold"
            style={{ backgroundColor: 'var(--bg-card3)', color: 'var(--accent)', borderTop: '1px solid var(--border)' }}>
            Lihat Profil Lengkap →
          </button>
        </div>
      )}
    </div>
  );
}
